module.exports = __webpack_public_path__ + "img/Group3002.eb42bcf5.svg";